import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { SitelogoComponent } from './sitelogo/sitelogo.component';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    // USADO PARA REEMPLAZAR SLOTS // NOSONAR
    // provideOutlet({ // NOSONAR
    //   id: 'SiteLogo',
    //   position: OutletPosition.BEFORE,
    //   component: SitelogoComponent,
    // }),
  ],
})
export class CustomSlotsModule { }
